import Swiper, {EffectFade, Thumbs} from 'swiper';

const personsSlider = document.querySelector('.j-persons-slider');
const personsThumbSlider = document.querySelector('.j-persons-thumb-slider');
const personsImageSlider = document.querySelector('.j-persons-image-slider');
let slider = {};
let thumbSlider = {};
let imageSlider = {};

if (personsThumbSlider) {
    const thumbsOptions = {
        init               : false,
        loop               : false,
        speed              : 800,
        spaceBetween       : 0,
        slidesPerView      : 'auto',
        slidesOffsetAfter  : 0,
        watchSlidesProgress: true
    };

    thumbSlider = new Swiper(personsThumbSlider, thumbsOptions);
    thumbSlider.init();
}

if (personsImageSlider) {
    const imageSliderOptions = {
        init               : true,
        loop               : false,
        speed              : 800,
        spaceBetween       : 0,
        slidesPerView      : 1,
        slidesOffsetAfter  : 0,
        watchSlidesProgress: true
    };

    imageSlider = new Swiper(personsImageSlider, imageSliderOptions);
    imageSlider.init();

    imageSlider.on('slideChange', () => {
        slider.slideTo(imageSlider['realIndex']);
    });
}


if (personsSlider) {
    const options = {
        modules          : [EffectFade, Thumbs],
        init             : false,
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 1,
        slidesOffsetAfter: 0,
        effect           : 'fade',
        fadeEffect       : {
            crossFade: true
        },
        breakpoints: {
            1280: {
                allowTouchMove: false,
                spaceBetween  : 0
            }
        },
        thumbs: {
            swiper: thumbSlider
        }
    };

    slider = new Swiper(personsSlider, options);
    slider.init();

    slider.on('slideChange', () => {
        imageSlider.slideTo(slider['realIndex']);
    });
}


